export const validateLogin = (username, password) => {
    const errors = {};
    if (!username) errors.username = "Username is required";
    if (!password) errors.password = "Password is required";
    return errors;
  };
  
  export const validateSignup = (username, password, email) => {
    const errors = {};
    if (!username) errors.username = "Username is required";
    if (!password || password.length < 6) errors.password = "Password must be at least 6 characters";
    if (!email || !/\S+@\S+\.\S+/.test(email)) errors.email = "Valid email is required";
    return errors;
  };